import { render, staticRenderFns } from "./ReportsDataTable.vue?vue&type=template&id=6b432bb0&scoped=true"
import script from "./ReportsDataTable.vue?vue&type=script&lang=js"
export * from "./ReportsDataTable.vue?vue&type=script&lang=js"
import style0 from "./ReportsDataTable.vue?vue&type=style&index=0&id=6b432bb0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b432bb0",
  null
  
)

export default component.exports